import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { LockKey } from '@phosphor-icons/react';

export const SignupUnavailable = () => (
  <div
    className="min-h-screen flex items-center justify-center bg-white p-8"
    data-testid="signup-unavailable"
  >
    <Card className="w-full max-w-md border shadow-sm">
      <CardHeader className="items-center text-center">
        <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center mb-3">
          <LockKey size={24} weight="duotone" className="text-slate-500" />
        </div>
        <CardTitle className="text-slate-900" style={{ fontFamily: 'Manrope' }}>
          Registration unavailable
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        <p className="text-sm text-slate-600">
          Self-service registration is currently closed. Please contact your
          administrator to request access.
        </p>
        <Link to="/login">
          <Button className="w-full" data-testid="signup-unavailable-login-btn">
            Back to sign in
          </Button>
        </Link>
      </CardContent>
    </Card>
  </div>
);

export default SignupUnavailable;
